document.querySelectorAll('.js-open-menu').forEach((btn)=>{
	btn.addEventListener('click',()=>{
		if (body.classList.contains('_open-menu')) {
			body.classList.remove('_open-menu')
		} else {
			body.classList.add('_open-menu')
		}
	})
})
document.querySelectorAll('.menu__sub-menu a').forEach((link)=>{
	link.addEventListener('click',()=>{
		body.classList.remove('_open-menu')
	})
})
document.querySelectorAll('.js-close-menu').forEach((btn)=>{
	btn.addEventListener('click',()=>{
		body.classList.remove('_open-menu')
	})
})
document.querySelectorAll('.js-menu-dropdown').forEach((link)=>{
	link.addEventListener('click',(e)=>{
		e.preventDefault();
		if(link.classList.contains('_open')){
			link.classList.remove('_open')
		}else{
			document.querySelectorAll('.js-menu-dropdown._open').forEach((l)=>{
				l.classList.remove('_open')
			})
			link.classList.add('_open')
		}
	})
})
